/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Label from "../../../components/label";
import ICSelect from "../../../components/form/selectInput";
import ICButton from "../../../components/button";
import TableList from "../../../containers/InstantSwitch/AssessmentListTable/assessmentListTable";
import MakeAPICall from "../../../apiCalls/common";
import { ORDER_HISTORY_FILTERS } from "../../../constants/helperConstants";
import { CSVLink } from "react-csv";

class AssessmentListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiCall: null,
      doctorId: props.auth._id,
      assessmentStatus: [
        {
          id: 0,
          name: "To Be Assessed",
          status: ORDER_HISTORY_FILTERS.TO_BE_ASSESSED
        },
        {
          id: 1,
          name: "Accepted",
          status: ORDER_HISTORY_FILTERS.ACCEPTED
        },
        {
          id: 2,
          name: "Completed",
          status: ORDER_HISTORY_FILTERS.COMPLETED
        },
        {
          id: 3,
          name: "Rejected",
          status: ORDER_HISTORY_FILTERS.REJECTED
        },
        {
          id: 4,
          name: "All",
          status: ORDER_HISTORY_FILTERS.ALL
        }
      ],
      selectedStatus: ORDER_HISTORY_FILTERS.TO_BE_ASSESSED,
      selectedStatusText: 0,
      apiLoading: false,
      assessmentData: null, // for csv
      headers: [ // heaaders for csv
        { label: "Appointment ID", key: "appointmentId" },
        { label: "Date Received", key: "submittedDate" },
        { label: "Doctor", key: "doctorName" },
        { label: "Doctor UIN", key: "doctorUIN" },
        { label: "Patient", key: "patientNameOnly" },
        { label: "Patient UIN", key: "patientUIN" },
        { label: "Subject", key: "assessmentType" },
        { label: "Status", key: "status" },
        { label: "Date Completed", key: "completedDate" }
      ]
    };
  }

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  getFilteredAssessments = (index) => {
    this.setState({
      selectedStatus: this.state.assessmentStatus[index].status,
      selectedStatusText: this.state.assessmentStatus[index].id
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  updateAssessmentData = (data) => {
    this.setState({
      assessmentData: data
    });
  };

  downloadCSVFile = () => {
    document.querySelector("#downloadCSV").click(); // pure js to get the click event + ref is not working with CSVLink element
  };

  // acceptAssessment(assessmentId) {
  //     const dataToSend = {
  //         assessmentId: assessmentId,
  //     };
  //     let apiCallParam = {
  //         reqType: "POST",
  //         reqURL: acceptAssessmentAPI,
  //         dataObj: dataToSend,
  //         params: {},
  //         headers: {},
  //         successCallback: res => {
  //             console.log("Got the assessment details: ", res);
  //             const { history } = this.props;
  //             if (history) history.push(appRoutes.instantSwitchAcceptAssessment);
  //         },
  //         failureCallback: err => {
  //             console.log("Something went wrong. Please try again ", err);
  //             this.setState({
  //                 apiLoading: false
  //             });
  //         },
  //     };
  //     console.log("Got params: ", apiCallParam);
  //     // this.componentAPICall(apiCallParam);
  // }

  render() {
    return (
      <div className="row rounded p-3 assessment-page">
        {/* Top Filters */}
        <div className="col-sm-6 p-3">
          <Label title="Online Assessments" className="big" />
        </div>
        <div className="col-sm-6 p-3 pt-3">
          <div className="text-right float-right">
            <ICButton title="Export To CSV" className="" clickEvent={this.downloadCSVFile} />
          </div>
          <div className="w-50 float-right mr-4">
            <ICSelect
              label=""
              useId="id"
              useValue="name"
              placeholder="Select Assessment Status"
              id="status"
              value={this.state.selectedStatusText !== "" ? this.state.selectedStatusText : "Select Assessment Status"}
              items={this.state.assessmentStatus}
              handleChange={this.getFilteredAssessments}
            />
          </div>
          {/* <div className="w-50 float-right mr-4">
                        <ICButton title="Export To CSV" className="float-right" clickEvent={this.downloadCSVFile} />
                        <div className="float-right w-auto">
                        </div>
                    </div> */}
        </div>

        <div className="col-sm-12 border-bottom"></div>
        <div className="col-sm-12 mt-5">
          <TableList assessmentType="Smoking Cessation" makeAPICall={this.componentAPICall} statusFilter={this.state.selectedStatus}
                     doctorId={this.state.doctorId} updateAssessmentData={this.updateAssessmentData} />
        </div>
        <div className="d-none p-3 text-right">
          {this.state.assessmentData && this.state.assessmentData.length ?
            <CSVLink id="downloadCSV" ref={this.csvInput} filename="OnlineAssessment.csv" className="d-none"
                     data={this.state.assessmentData} headers={this.state.headers}> Download me </CSVLink>
            : ""}
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

const mapStateToProps = props => ({
  auth: props.auth && props.auth.user && props.auth.user.userData ? props.auth.user.userData : {}
});

const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AssessmentListPage));
